/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Routes constants
 */

export const APARTMENTS = 'apartments'
export const CHEAP_APARTMENTS = 'cheap-apartments'
export const CONDOS = 'condos'
export const HOUSES = 'houses'
export const LUXURY_APARTMENTS = 'luxury-apartments'
export const MOVE_IN_SPECIAL = 'move-in-special'
export const NO_DEPOSIT = 'no-deposit'
export const PET_FRIENDLY_APARTMENTS = 'pet-friendly-apartments'
export const ROOMS = 'rooms'
export const SHORT_TERM_RENTALS = 'short-term-rentals'

export const HOMEPAGE = 'Homepage'
export const HOMEPAGE_ZUMPER_RENTALS = 'HomepageZumperRentals'
export const NEAR_ME = 'NearMe'
export const VALID_NEAR_ME_TYPE_ROUTES = [
  APARTMENTS,
  CHEAP_APARTMENTS,
  CONDOS,
  HOUSES,
  LUXURY_APARTMENTS,
  MOVE_IN_SPECIAL,
  NO_DEPOSIT,
  PET_FRIENDLY_APARTMENTS,
  ROOMS,
  SHORT_TERM_RENTALS,
] as const
export const FOR_YOU = 'ForYou'
// detailRoutes
export const FULL_DETAIL_VIEW = 'FullDetailView'
export const PERMANENT_ADDRESS = 'PermanentAddress'
// maplist / rail routes
export const CURRENT_SEARCH_ROUTE = 'CurrentSearchRoute'
export const FAVORITES_ROUTE = 'FavoritesRoute'
export const MESSAGED_ROUTE = 'MessagedRoute'
export const SAVED_SEARCHES_ROUTE = 'SavedSearchesRoute'
export const SAVED_SEARCHES_SUMMARY_ROUTE = 'SavedSearchesSummaryRoute'
// other
export const ABOUT_LANDING = 'AboutLanding'
export const ZUMPER_RENTALS_ABOUT_PAGE = 'ZumperRentalsAboutPage'
export const AI_ASSISTANT = 'AIAssistant'
export const STR_LANDING = 'StrLanding'
export const AFFORDABILITY_CALCULATOR = 'AffordabilityCalculator'
export const CAREERS_PAGE = 'CareersPage'
export const CCPA_CONFIRMATION = 'CcpaConfirmationPage'
export const CCPA_REQUEST = 'CcpaRequestPage'
export const COMMUNITY_LISTINGS_TERMS = 'CommunityListingsTerms'
export const FAIR_HOUSING = 'FairHousing'
export const GOOGLE_POSTING_SERVICES_TERMS = 'GooglePostingServicesTerms'
export const MESSAGES_PAGE = 'PageMessages'
export const NEWSROOM_PAGE = 'NewsroomPage'
export const NOTIFICATION_SETTINGS = 'NotificationSettings'
export const PRIVACY_POLICY = 'PrivacyPolicy'
export const PRIVACY_POLICY_10_2022 = 'PrivacyPolicy102022'
export const RENT_RESEARCH_DETAIL = 'RentResearchDetail'
export const RENT_RESEARCH_HOMEPAGE = 'RentResearchHomepage'
export const SIGNATURE_VIRTUAL_TERMS = 'SignatureVirtualTerms'
export const SITEMAP_ENTRY_POINT = 'SitemapEntryPoint'
export const SITEMAP_CHILD_PAGE = 'SitemapChildPage'
export const SNAPPR_TERMS = 'SnapprTerms'
export const STR_PROVIDER_INTERSTITIAL = 'STRProviderInterstitial'
export const TRANSUNION_TOS = 'TransunionTOS'
export const TERMS_AND_CONDITIONS = 'TermsAndConditions'
export const VIRTUAL_TOURS_PAGE = 'VirtualToursPage'
export const REVIEWS_TERMS = 'ReviewsTerms'
export const NURTURE_BOSS_TERMS = 'NurtureBossTerms'
export const SIGN_IN = 'SignIn'
export const SIGN_UP = 'SignUp'
export const ZUMPER_ACCOUNT = 'ZumperAccount'

// url constants for routes
export const ADDR_BASE_URL = 'address'
export const APTS_BASE_URL = 'apartments-for-rent'
export const VACATION_BASE_URL = 'vacation'
export const BLDG_BASE_URL = 'apartment-buildings'
export const LISTING_BASE_URL = 'listings'
export const CONDOS_BASE_URL = 'condos-for-rent'
export const HOUSES_BASE_URL = 'houses-for-rent'
export const ROOMS_BASE_URL = 'rooms-for-rent'
export const INITIAL_COLOR_MODE = 'light'
export const COUNTRY_CODE = 'us'
export const ADVERTISE_URL = 'https://advertise.zumper.com/'
export const MULTIFAMILY_URL = 'https://multifamily.zumper.com/'

export const NZR_HOMEPAGE = '/'
export const NZR_FAVORITES = '/favorites'
export const NZR_MESSAGED = '/messaged'
export const NZR_ALERTS = '/alerts'
export const NZR_APTS = `/${APTS_BASE_URL}`
export const NZR_APTS_MAP = `/map/${APTS_BASE_URL}`
export const NZR_APTS_SELECT = '/select'
export const NZR_BLDG = `/${BLDG_BASE_URL}`
export const NZR_BLDG_SEP = 'apartments-at'
export const MANAGE = '/manage'
export const DJP_APT_SEP = 'apartment-at'
// messaging
export const MESSAGING_BASE_PATH = '/messages'
export const MESSAGING_LOGIN_PATH = `${MESSAGING_BASE_PATH}/get-started`
export const MESSAGING_SIGNUP_PATH = `${MESSAGING_BASE_PATH}/sign-up`

// regex
export const CITY_STATE_HOOD_RE = /^\w[-\w.']+-[a-z]{2}\/[\w.'][-\w.']+$/i
export const CITY_STATE_RE = /^\w[-\w.']+-[a-z]{2}$/i
export const DETAIL_RE = /(?:a|b|p)?\d+/
export const NEAR_UNIVERSITY_RE = /\/near(.*)(college|university)(.*)+-[a-z]{2}/
export const STATE_RE = /^[a-z]{2}$/i
export const FILTERS_START_RE =
  /\/(?:furnished|short-term|low-income|move-in-special|no-security-deposit|utilities-included|luxury|cheap|no-fee|income-restricted|senior-living|student-housing|on-site-laundry|deals-only|parking|outdoor-space|pets-allowed|pet-friendly|dog-friendly|cat-friendly|today|over-\d+|under-\d+|price[-,:]?[\d,]+(?:[,-][\d,]+?)?|nightly-over-\d+|nightly-under-\d+|nightly-price[-,:]?[\d,]+(?:[,-][\d,]+?)?|studios?\+?|\d[+-]beds?|(?:(?:studios?|\d),){1,4}\d[+-]beds?)(?:\/|\?|$)/
export const PROPERTY_TYPE_PATH_RE = /(?:(?:apartments|condos|houses|rooms)-for-rent)|rentals/
export const URL_BASE_RE = new RegExp(`${NZR_APTS}|${NZR_APTS_MAP}|${NZR_APTS_SELECT}|${NZR_BLDG}`)
export const DIGITS_RE = /^[0-9]+$/
export const BATHROOMS_RE = /bathrooms/
export const BEDROOMS_RE = /(\d[+-])beds?|((?:(?:studios?|\d),){1,4}\d[+-])beds?/
export const LUXURY_RE = /cheap|luxury/
export const NIGHTLY_OVER_RE = /nightly-over-(\d+)/
export const NIGHTLY_PRICE_RANGE_RE = /nightly-price[-,:]?([,\d]+)(?:[,-]([\d,]+))?/
export const NIGHTLY_UNDER_RE = /nightly-under-(\d+)/
export const OVER_RE = /over-(\d+)/
export const PRICE_RANGE_RE = /price[-,:]?([,\d]+)(?:[,-]([\d,]+))?/
export const STUDIO_RE = /studios?(\+)?(?![-,+s\d])/
export const UNDER_RE = /under-(\d+)/
// end of regex

export const PROPERTY_TYPES = [APARTMENTS, CONDOS, HOUSES, ROOMS] as const

export const FILTERS_PATH_RE =
  /(?:[/](?:furnished|short-term|low-income|luxury|no-security-deposit|move-in-special|utilities-included|cheap|no-fee|pet-friendly|dog-friendly|cat-friendly|on-site-laundry|today|over-\d+|under-\d+|price[-,:]?[\d,]+(?:[-,][\d,]+?)?|nightly-over-\d+|nightly-under-\d+|nightly-price[-,:]?[\d,]+(?:[,-][\d,]+?)?|studios?\+?|\d[-+]beds?|(?:(?:studios?|\d),){1,4}\d[-+]beds?))+[/]?/
export const LISTING_ID_RE = /\d+[apb]?/

export const LEGACY_LISTING_DETAIL_RE = new RegExp(`^/apartments-for-rent/${LISTING_ID_RE.source}`)
export const AFR_FACET_RE = new RegExp(`^/apartments-for-rent/.*${FILTERS_PATH_RE.source}`)

const ZUMPER_RENTALS_PATTERNS: RegExp[] = [
  /^\/houses-for-rent/,
  /^\/rooms-for-rent/,
  /^\/address/,
  /^\/listings/,
  LEGACY_LISTING_DETAIL_RE,
  AFR_FACET_RE,

  // below are urls that not served by NZR but have the zumperrentals host - do not include in redirect alerts
  /^\/blog/,
  /^\/manage\/resources/,
]

const ZUMPER_RENTALS_NO_REDIRECT_PATTERNS: RegExp[] = [
  /^\/$/,
  /^\/sitemap/,
  /^\/about/,
  /^\/privacy-policy/,
  /^\/terms-and-conditions/,
  /^\/fair-housing-rights/,
  /^\/messages/,
  /^\/favorites/,
  /^\/alerts/,
  /^\/settings/,
  /^\/apartment-buildings/, // apartment building redirects handled in buildingSuccessHandler
]

export const ZUMPER_RENTALS_PATH_PATTERN = new RegExp(
  ZUMPER_RENTALS_PATTERNS.map((pattern) => pattern.source).join('|')
)
export const ZUMPER_RENTALS_NO_REDIRECT_PATH_PATTERN = new RegExp(
  ZUMPER_RENTALS_NO_REDIRECT_PATTERNS.map((pattern) => pattern.source).join('|')
)
